import { render, staticRenderFns } from "./video-protocol.vue?vue&type=template&id=1d40b588&scoped=true&"
import script from "./video-protocol.vue?vue&type=script&lang=js&"
export * from "./video-protocol.vue?vue&type=script&lang=js&"
import style0 from "./video-protocol.vue?vue&type=style&index=0&id=1d40b588&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40b588",
  null
  
)

export default component.exports